module.exports = __webpack_public_path__ + "img/knowledge.7e5ae710.svg";